var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('message.aboutTitle')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('message.aboutContent'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }